import { useEffect } from 'react';
import { Redirect, Route, Switch } from 'wouter';

import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AuthProvider } from '@/hooks/useAuth';
import { ApiKeysPage } from '@/pages/ApiKeysPage';
import { LoginPage } from '@/pages/LoginPage';
import { PublicSimulationPage } from '@/pages/PublicSimulationPage';
import { SimulationPage } from '@/pages/SimulationPage';
import { SimulationsListPage } from '@/pages/SimulationsListPage';
import { TeamsPage } from '@/pages/TeamsPage';
import { RequireAuth } from '@/routes/RequireAuth';
import { usePrintMode } from '@/store/usePrintMode';

export function App() {
  // Bascule les graphiques en dimensions fixes lors d'une impression déclenchée
  // depuis le navigateur (Ctrl+P), pour qu'ils restent visibles dans le PDF.
  useEffect(() => {
    const { setPrinting } = usePrintMode.getState();
    const before = () => setPrinting(true);
    const after = () => setPrinting(false);
    window.addEventListener('beforeprint', before);
    window.addEventListener('afterprint', after);
    return () => {
      window.removeEventListener('beforeprint', before);
      window.removeEventListener('afterprint', after);
    };
  }, []);

  return (
    <AuthProvider>
      <TooltipProvider>
        <Switch>
          <Route path="/login" component={LoginPage} />
          <Route path="/p/:slug" component={PublicSimulationPage} />
          <Route path="/">
            <RequireAuth>
              <SimulationsListPage />
            </RequireAuth>
          </Route>
          <Route path="/s/:id">
            <RequireAuth>
              <SimulationPage />
            </RequireAuth>
          </Route>
          <Route path="/teams">
            <RequireAuth>
              <TeamsPage />
            </RequireAuth>
          </Route>
          <Route path="/api-keys">
            <RequireAuth>
              <ApiKeysPage />
            </RequireAuth>
          </Route>
          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </TooltipProvider>
      <Toaster />
    </AuthProvider>
  );
}
